import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Image } from '@outdoor-voices/ui';
import PropTypes from 'prop-types';
import { Category } from '../../homepage/Category';
import css from './Categories.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Categories = function Categories(_ref) {
  var image = _ref.image,
      component = _ref.component;
  return /*#__PURE__*/_jsxs("section", {
    className: css.root,
    children: [/*#__PURE__*/_jsx("div", {
      className: css.image,
      children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
        wrap: false,
        lazyload: false,
        sizes: [320, 480, 600, 800, 1000, 1200, 1440, 2840]
      }))
    }), /*#__PURE__*/_jsx(Category, _objectSpread(_objectSpread({}, component), {}, {
      lazyload: true
    }))]
  });
};

Categories.propTypes = {
  component: PropTypes.shape({}),
  image: PropTypes.shape({})
};
export default Categories;